exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".about {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1em; }\n  .about h3 {\n    border-bottom: 2px solid #1A1A1A; }\n", ""]);

